export default __webpack_public_path__ + "static/media/bs-secondary-sedan.898d1fb2.svg";